// extracted by mini-css-extract-plugin
export default {"loadingBox":"FlexLoadingBox_loadingBox__rvX2A","icon":"FlexLoadingBox_icon__VWMO-"};